/**
 * TourPrompt — Post-onboarding "Want a quick tour?" modal (#1559)
 *
 * Mounts after the user finishes OnboardingModal, asking if they want
 * the guided tour. Either choice writes tour_completed_at so the prompt
 * does not re-show.
 *
 * State machine:
 *   onboarding_completed=1 AND tour_completed_at=NULL → prompt visible
 *   "Yes" → starts tour (TourProvider persists on tour end)
 *   "No thanks" → calls dismiss() (immediate persist), prompt unmounts
 */

import { useTour } from './useTour';

export function TourPrompt() {
  const { start, dismiss } = useTour();

  const handleStart = () => {
    start();
  };

  const handleDismiss = async () => {
    await dismiss();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="tour-prompt-title"
        className="relative w-full max-w-sm rounded-2xl bg-oro-surface border border-oro-border shadow-2xl p-6"
      >
        <h2
          id="tour-prompt-title"
          className="text-[20px] font-semibold text-text-primary mb-2"
        >
          Want a quick tour?
        </h2>
        <p className="text-[14px] text-text-secondary mb-6 leading-relaxed">
          We'll show you where everything lives — clubs, activities, chat, and your profile.
        </p>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={handleStart}
            className="w-full min-h-11 px-4 py-3 bg-accent text-black font-semibold rounded-lg hover:opacity-90 transition-opacity"
          >
            Yes, show me
          </button>
          <button
            type="button"
            onClick={handleDismiss}
            className="w-full min-h-11 px-4 py-3 text-text-secondary hover:text-text-primary transition-colors text-[14px]"
          >
            No thanks
          </button>
        </div>
      </div>
    </div>
  );
}
